import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BasketBallCourt(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M4.064 11.986A.994.994 0 004 11.984a7.977 7.977 0 01.57-2.956 12.021 12.021 0 015.025.718C8.238 11.154 6.432 12 4.498 12c-.146 0-.29-.005-.434-.014zm7.415-1.344C9.752 12.696 7.283 14 4.499 14c-.083 0-.166-.001-.248-.004a8.008 8.008 0 006.76 5.943 8.865 8.865 0 01-.011-.432c0-2.688 1.14-5.12 3.005-6.859a11.629 11.629 0 00-2.526-2.006zm4.13.792a13.626 13.626 0 00-2.994-2.443 11.224 11.224 0 001.386-4.739 8.014 8.014 0 015.75 5.76c-1.52.183-2.925.68-4.142 1.422zm-.354 2.786C13.842 15.596 13 17.473 13 19.507c0 .144.005.287.013.43a7.96 7.96 0 003.884-1.61 10.918 10.918 0 00-1.642-4.107zm3.289 2.383a12.965 12.965 0 00-1.686-3.586A8.33 8.33 0 0120 11.997V12a7.964 7.964 0 01-1.456 4.603zm-7.709-8.516a13.975 13.975 0 00-5.084-1.083A7.985 7.985 0 0112 4h.012a9.155 9.155 0 01-1.177 4.087zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z",
    clipRule: "evenodd"
  }));
}

export default BasketBallCourt;